import { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { initDna } from '../utils/dnaCanvas'

const COUNTER_INITIAL = 381183
const COUNTER_INTERVAL_MS = 1650

export function Home() {
  const [entered, setEntered] = useState(false)
  const [counter, setCounter] = useState(COUNTER_INITIAL)
  const landingCanvasRef = useRef<HTMLCanvasElement>(null)
  const labCanvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const t = setInterval(() => setCounter((c) => c + 1), COUNTER_INTERVAL_MS)
    return () => clearInterval(t)
  }, [])

  useEffect(() => {
    if (!landingCanvasRef.current) return
    return initDna(landingCanvasRef.current, 1.5, 0.75)
  }, [])

  useEffect(() => {
    if (!entered || !labCanvasRef.current) return
    return initDna(labCanvasRef.current, 1, 0.75)
  }, [entered])

  return (
    <div className={`home-views ${entered ? 'view-active' : ''}`}>
      <section className="landing-view" aria-hidden={entered}>
        <canvas ref={landingCanvasRef} className="landing-canvas" />
        <nav className="nav-minimal">
          <div className="nav-brand">
            <span className="nav-brand-title">THE ULTIMATE OPENCLAW GUIDE</span>
            <span className="nav-brand-sub">
              <span className="nav-brand-by">by </span>
              <a href="https://www.limenlab.ai" target="_blank" rel="noopener noreferrer" className="nav-brand-link">LIMEN AI LAB</a>
            </span>
          </div>
          <Link to="/enterprise" className="nav-enterprise-link">企业部署服务解决方案</Link>
        </nav>
        <div className="mission-overlay">
          <h2><span className="keep-case">OpenClaw</span><br />全网最全部署指南</h2>
          <p className="counter-line">
            20分钟，8岁到80岁都能开始养上自己的小龙虾。<br />
            你还在犹豫的这一秒，已有{' '}
            <span className="counter-flap-wrap" aria-label={counter.toLocaleString()}>
              {[...counter.toLocaleString()].map((char, i) => (
                <span className="counter-flap" key={`${i}-${char}`}>
                  {char}
                </span>
              ))}
            </span>{' '}
            人超越你！
          </p>
        </div>
        <div className="enter-container">
          <button
            type="button"
            className="enter-btn"
            onClick={() => setEntered(true)}
          >
            <span>进入</span>
            开始使用 —
          </button>
        </div>
      </section>

      <section className="lab-view" aria-hidden={!entered}>
        <canvas ref={labCanvasRef} className="dna-canvas-main" />
        <div className="page">
          <section className="hero">
            <h1>赋予你的 AI 执行的双手</h1>
            <p className="lead">
              OpenClaw 是爆火的开源本地优先 AI 智能体框架。本站在本地为你提供智能引导、场景化教程与玩家社区，零门槛上手。
            </p>
            <div className="hero-actions">
              <Link to="/wizard" className="btn btn-primary">
                开始智能引导 —
              </Link>
              <Link to="/deploy" className="btn btn-ghost">
                部署专区
              </Link>
            </div>
          </section>

          <section className="section-title">热门入口</section>
          <div className="card-grid">
            <Link to="/wizard" className="card card-link">
              <h3>智能引导中心</h3>
              <p>回答几个问题，获取专属部署方式与 Skills 推荐、一键配置命令（全部在浏览器内生成，不上传密钥）。</p>
            </Link>
            <Link to="/deploy" className="card card-link">
              <h3>部署专区</h3>
              <p>本地安装（Win/Mac）、云端一键（Hostinger/腾讯云）、Docker 进阶，按场景选方案。</p>
            </Link>
            <Link to="/channels" className="card card-link">
              <h3>通道对接</h3>
              <p>飞书、Telegram、Discord、WhatsApp、终端 TUI 等专题配置。</p>
            </Link>
            <Link to="/skills" className="card card-link">
              <h3>技能市场选品</h3>
              <p>精选实用 Skills 排行，避开 ClawHub 恶意水件，安全使用。</p>
            </Link>
            <Link to="/sec-fix" className="card card-link">
              <h3>安全与排障</h3>
              <p>沙盒配置、<code>openclaw doctor</code> 修复、常见报错与安全红线。</p>
            </Link>
            <Link to="/community" className="card card-link">
              <h3>玩家社区</h3>
              <p>抄作业广场、一键配置生成、黑红榜与安全测评。</p>
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
